import * as React from 'react';
import ProfileMetrics from 'src/value-objects/ProfileMetrics';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';

import PieChart from 'react-minimal-pie-chart';

import './MyPortfolioSummary.css';

export interface Props {
  metrics?: ProfileMetrics;
}

const colors = [
  '#d4dcbb',
  '#88b04b',
  '#505050',
  '#F48E28',
];

const MyPortfolioSummaryComponent: React.StatelessComponent<Props> = (props: Props) => {
  if (!props.metrics) {
    return null;
  }
  const assets = props.metrics.portfolioCompositionByAsset;
  const sectors = props.metrics.portfolioCompositionBySector;
  const types = props.metrics.portfolioCompositionByType;

  return (
    <div className="my-portfolio-summary">
      <div className="tab-content padding-l-r-0">
        <div className="row">
          <div className="col-sm-6 col-md-4">
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="./img/ticket-medio_2.svg"
              />
              <p className="inline-block f-s-20">
                Capital comprometido:
                <br/>
                <strong>
                  {NumberFormater.euros(props.metrics.commitedCapitalNonFailedProjects, 0)}
                </strong> <span className="f-s-16 c-grey">
                  en {props.metrics.numberOfCommitments} startups
                </span>
              </p>
            </div>
            {Object.keys(types).length > 0 ?
              <div className="row padding-20">
                <div className="col-sm-4 chart-container">
                  <PieChart
                    data={Object.keys(types).map((type, index) => ({value: types[type], color: colors[index % 4]}))}
                    lineWidth={25}
                  />
                </div>
                <div className="col-md-8">
                  <h4 className="f-w-100">Tipo de inversión:</h4>
                  {Object.keys(types).map(type => (
                    <p className="f-s-16"><strong>{NumberFormater.percent(types[type])}</strong> {type}</p>
                  ))}
                </div>
              </div> :
              null
            }
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="./img/documentos-copy-8.svg"
              />
              <p className="inline-block f-s-20">
                Capital invertido:
                <br/>
                <strong>{NumberFormater.euros(props.metrics.investedCapitalNonFailedProjects, 0)}</strong>
              </p>
            </div>
            {Object.keys(sectors).length > 0 ?
              <div className="row padding-20">
                <div className="col-sm-4 chart-container">
                  <PieChart
                    data={Object
                      .keys(sectors)
                      .map((sector, index) => ({value: sectors[sector], color: colors[index % 4]}))}
                    lineWidth={25}
                  />
                </div>
                <div className="col-md-8">
                  <h4 className="f-w-100">Sector de inversión:</h4>
                  {Object.keys(sectors).map(sector => (
                    <p className="f-s-16"><strong>{NumberFormater.percent(sectors[sector])}</strong> {sector}</p>
                  ))}
                </div>
              </div> :
              null
            }
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="./img/ticket-medio.svg"
              />
              <p className="inline-block f-s-20">
                Ticket medio:
                <br/>
                <strong>{NumberFormater.euros(props.metrics.averageTicket, 0)}</strong>
              </p>
            </div>
            {Object.keys(assets).length > 0 ?
              <div className="row padding-20">
                <div className="col-sm-4 chart-container">
                  <PieChart
                    data={Object.keys(assets).map((asset, index) => ({value: assets[asset], color: colors[index % 4]}))}
                    lineWidth={25}
                  />
                </div>
                <div className="col-md-8">
                  <h4 className="f-w-100">Valor de la cartera:</h4>
                  {Object.keys(assets).map(asset => (
                    <p className="f-s-16"><strong>{NumberFormater.percent(assets[asset])}</strong> {asset}</p>
                  ))}

                </div>
              </div> :
              null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPortfolioSummaryComponent;


// WEBPACK FOOTER //
// ./src/modules/my-portfolio/partials/MyPortfolioSummary.component.tsx